class MaritaTheme {
  constructor() {
    this.drawer = document.querySelector('#CartDrawer');
    this.config = window.maritaTheme || {};
    document.addEventListener('click', (event) => this.onClick(event));
    this.cleanImportedCitationArtifacts();
  }

  onClick(event) {
    const open = event.target.closest('[data-cart-open]');
    const close = event.target.closest('[data-cart-close]');
    const change = event.target.closest('[data-cart-change]');
    if (open) { event.preventDefault(); this.openCart(); }
    if (close) this.drawer?.close();
    if (change) { event.preventDefault(); this.changeCart(change.dataset.key, Number(change.dataset.quantity)); }
  }

  rootPath(path) {
    const root = String(this.config.root || '/').replace(/\/?$/, '/');
    return `${root}${String(path || '').replace(/^\//, '')}`;
  }

  money(cents) {
    try {
      return new Intl.NumberFormat(this.config.locale || 'es-AR', {
        style: 'currency', currency: this.config.currency || 'ARS', maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (_) { return `$${Math.round(cents / 100).toLocaleString('es-AR')}`; }
  }

  escape(value = '') {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  async openCart() {
    if (!this.drawer) return;
    if (!this.drawer.open) this.drawer.showModal();
    await this.refreshCart();
  }

  async refreshCart() {
    const body = this.drawer?.querySelector('[data-cart-body]');
    if (!body) return;
    try {
      const response = await fetch(this.rootPath('cart.js'), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      body.innerHTML = this.renderCart(cart);
    } catch (_) {
      body.innerHTML = `<p>No pudimos actualizar el carrito.</p><a class="ma-button ma-button--full" href="${this.rootPath('cart')}">Ver carrito</a>`;
    }
  }

  renderCart(cart) {
    if (!cart.items.length) {
      return `<div class="ma-empty-cart"><p>Tu carrito está vacío.</p><a class="ma-button ma-button--full" href="${this.rootPath('collections/all')}">Ver productos</a></div>`;
    }
    const items = cart.items.map((item) => `
      <article class="ma-drawer-item">
        <a href="${this.escape(item.url)}"><img src="${this.escape(item.image || '')}" alt="${this.escape(item.product_title)}" loading="lazy"></a>
        <div><strong>${this.escape(item.product_title)}</strong>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${this.escape(item.variant_title)}</small>` : ''}<span>${item.quantity} × ${this.money(item.final_price)}</span><button class="ma-link-button" data-cart-change data-key="${this.escape(item.key)}" data-quantity="0">Eliminar</button></div>
        <strong>${this.money(item.final_line_price)}</strong>
      </article>`).join('');
    const threshold = Number(this.config.freeShippingThreshold || 0);
    let progress = '';
    if (threshold > 0) {
      const missing = Math.max(0, threshold - cart.total_price);
      const pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      progress = `<div class="ma-shipping-progress"><span>${missing > 0 ? `Te faltan ${this.money(missing)} para el envío gratis` : '¡Alcanzaste el envío gratis!'}</span><i style="width:${pct}%"></i></div>`;
    }
    return `${items}${progress}<div class="ma-drawer-footer"><p>Subtotal <strong>${this.money(cart.total_price)}</strong></p><a class="ma-button ma-button--full" href="${this.rootPath('cart')}">Revisar y finalizar</a></div>`;
  }

  async changeCart(key, quantity) {
    try {
      await fetch(this.rootPath('cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      await this.refreshCart();
    } catch (_) { this.announce('No pudimos actualizar el carrito.'); }
  }

  announce(message) {
    const region = document.querySelector('[data-live-region]');
    if (region) region.textContent = message;
  }

  cleanImportedCitationArtifacts() {
    document.querySelectorAll('[data-clean-imported-content]').forEach((element) => {
      element.innerHTML = element.innerHTML
        .replace(new RegExp(`\\[${'oai'}_${'citation'}:[^\\]]+\\]\\([^)]+\\)`, 'gi'), '')
        .replace(new RegExp(`\\[${'oai'}_${'citation'}:[^\\]]+\\]`, 'gi'), '');
    });
  }
}

document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => { window.maritaStorefront = new MaritaTheme(); });
